export const getPreviewShimmerStyles = () => ({
  '@keyframes animationIn': {
    from: { opacity: 0 },
    to: { opacity: 1 },
  },
  // Default/normal size shimmer container
  shimmerContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    maxWidth: '100%',
    '& .shimmer-title': {
      fontSize: '56px',
      fontWeight: 600,
      lineHeight: '64px',
      textAlign: 'center',
      margin: '0px 20px',
    },
    '& .shimmer-description': {
      fontSize: '32px',
      fontWeight: 400,
      lineHeight: '40px',
      textAlign: 'center',
      margin: '35px 0px 25px 0px',
      maxWidth: '750px',
    },
    '& .shimmer-progress': {
      margin: '5px 0px',
    },
    '& .input-shimmer': {
      animation: '$animationIn 0.8s forwards',
      marginTop: '36px',
      marginBottom: '40px',
      minHeight: '124px',
    },
    '& .circle-shimmers': {
      '& .ms-Shimmer-shimmerWrapper': {
        borderRadius: '100%',
      },
    },
  },
  // Large size shimmer container
  'shimmerContainer-l': {
    '& .shimmer-title': {
      fontSize: '64px',
      fontWeight: 600,
      lineHeight: '72px',
      textAlign: 'center',
      margin: '0px 24px',
    },
    '& .shimmer-description': {
      fontSize: '36px',
      fontWeight: 400,
      lineHeight: '44px',
      textAlign: 'center',
      margin: '40px 0px 30px 0px',
      maxWidth: '850px',
    },
  },

  // Medium size shimmer container
  'shimmerContainer-m': {
    '& .shimmer-title': {
      fontSize: '44px',
      fontWeight: 600,
      lineHeight: '52px',
      textAlign: 'center',
      margin: '0px 18px',
    },
    '& .shimmer-description': {
      fontSize: '28px',
      fontWeight: 400,
      lineHeight: '36px',
      textAlign: 'center',
      margin: '30px 0px 20px 0px',
      maxWidth: '650px',
    },
  },

  // Small size shimmer container
  'shimmerContainer-s': {
    '& .shimmer-title': {
      fontSize: '32px',
      fontWeight: 600,
      lineHeight: '35px',
      textAlign: 'center',
      margin: '0px 16px',
    },
    '& .shimmer-description': {
      fontSize: '20px',
      fontWeight: 400,
      lineHeight: '25px',
      textAlign: 'center',
      margin: '25px 0px 15px 0px',
      maxWidth: '100%',
    },
    '& .shimmer-progress': {
      margin: '5px 0px',
    },
    '& .input-shimmer': {
      animation: '$animationIn 0.8s forwards',
      marginTop: '36px',
      marginBottom: '40px',
      minHeight: '124px',
    },
    '& .circle-shimmers': {
      '& .ms-Shimmer-shimmerWrapper': {
        borderRadius: '100%',
      },
    },
  },
  adsShimmer: {
    animation: '$animationIn 0.8s forwards',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    margin: '0px 48px',
    height: '400px',
    '& .intro-shimmer': {
      maxWidth: '540px',
      flex: 1,
      marginRight: '80px',
      marginTop: '20px',
    },
  },
  'adsShimmer-l': {
    height: 'auto',
    flexDirection: 'column-reverse',
    alignItems: 'center',
    '& .intro-shimmer': {
      marginRight: '0px',
      marginBottom: '50px',
    },
  },
  'adsShimmer-m': {
    height: 'auto',
    flexDirection: 'column-reverse',
    alignItems: 'center',
    '& .intro-shimmer': {
      marginRight: '0px',
      marginBottom: '50px',
    },
  },
  'adsShimmer-s': {
    height: 'auto',
    flexDirection: 'column-reverse',
    alignItems: 'center',
    '& .intro-shimmer': {
      marginRight: '0px',
      marginBottom: '50px',
    },
  },
});
